(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3Subgroups', {
            templateUrl: 'app/club-admin/subgroups/subgroups.component.html',
            controller: SubgroupsComponent,
            bindings: {
                clubId: '<',
                subgroupList: '<',
                subgroup: '<',
                members: '<'
            }
        });

    var noop = angular.noop,
        copy = angular.copy;

    SubgroupsComponent.$inject = ['$element', '$timeout', '$window', '$q', 'Club', 'alert', 'confirm', 'clubAdminResources', 'subgroupMemberLookupPageSize', 'keys'];
    function SubgroupsComponent($element, $timeout, $window, $q, Club, alert, confirm, resources, subgroupMemberLookupPageSize, keys) {
        var ctrl = this,
            currentRefresh,
            currentSearch,
            saved,
            addMemberButton;

        // Properties
        Object.defineProperty(ctrl, 'isEditing', { get: getIsEditing });
        Object.defineProperty(ctrl, 'subgroupId', { get: getSubgroupId });

        // Subgroup
        ctrl.insertSubgroup = insertSubgroup;
        ctrl.editSubgroup = editSubgroup;
        ctrl.deleteSubgroup = deleteSubgroup;
        ctrl.saveSubgroup = saveSubgroup;
        ctrl.cancelSubgroup = cancelSubgroup;

        // Member
        ctrl.insertMember = insertMember;
        ctrl.removeMember = removeMember;
        ctrl.saveMember = saveMember;
        ctrl.cancelMember = cancelMember;

        // Misc
        ctrl.refresh = refresh;
        ctrl.search = search;
        ctrl.memberChanged = memberChanged;
        ctrl.editSubgroupKeyDown = editSubgroupKeyDown;
        ctrl.editMemberKeyDown = editMemberKeyDown;

        //////////////////////////////////////

        // ** Subgroup
        function insertSubgroup() {
            saved = { subgroup: ctrl.subgroup, members: ctrl.members };
            ctrl.subgroup = { clubId: ctrl.clubId, $isEditing: true };
            ctrl.members = [];
        }
        function editSubgroup() {
            saved = { subgroup: ctrl.subgroup, members: ctrl.members };
            ctrl.subgroup = copy(ctrl.subgroup);
            ctrl.subgroup.$isEditing = true;
        }
        function deleteSubgroup() {
            var clubId = ctrl.clubId,
                subgroup = ctrl.subgroup;

            confirm(resources.confirmDeleteSubgroup).then(deleteSubgroup, noop);

            function deleteSubgroup() {
                Club.deleteSubgroup({ id: clubId }, subgroup, success, error, true);

                function success() {
                    removeFromArray(ctrl.subgroupList, subgroup);
                    ctrl.subgroup = null;
                    ctrl.refresh();
                }
                function error() {
                    alert.error(resources.deleteSubgroupFailed)
                }
            }

        }
        function saveSubgroup() {
            var clubId = ctrl.clubId,
                subgroup = ctrl.subgroup,
                isNew = !subgroup.id;

            if (ctrl.form.$valid)
                Club.saveSubgroup({ id: clubId }, subgroup, success, error, true);

            function success(data) {
                if (!isNew) {
                    cancelSubgroup();
                    copy(data, ctrl.subgroup);
                }
                else {
                    ctrl.subgroupList.push(ctrl.subgroup = data);
                    ctrl.members = [];
                }
            }
            function error() {
                alert.error(resources.saveSubgroupFailed);
            }
        }
        function cancelSubgroup() {
            ctrl.subgroup = saved.subgroup;
            ctrl.members = saved.members;
        }

        // ** Member
        function insertMember() {
            ctrl.members.push({});
            $window.scrollTo(0, $window.document.body.scrollHeight);
        }
        function removeMember(member) {
            var clubId = ctrl.clubId;
            confirm(resources.confirmRemoveMemberFromSubgroup).then(removeMember, noop);

            function removeMember() {
                Club.removeSubgroupMember({ id: clubId }, member, success, error, true);

                function success() {
                    removeFromArray(ctrl.members, member);
                }
                function error() {
                    alert.error(resources.removeMemberFromSubgroupFailed)
                }
            }
        }
        function saveMember(member, form) {
            var clubId = ctrl.clubId,
                subgroupId = ctrl.subgroupId;

            if (form.$valid) {
                member.clubSubgroupId = subgroupId;
                Club.addSubgroupMember({ id: clubId }, member, success, error, true);
            }

            function success(data) {
                copy(data, member);
                focusAddNewButton();
            }

            function error() {
                member.clubSubgroupId = null;
                alert.error(resources.addSubgroupMemberFailed);
            }
        }
        function cancelMember(member) {
            removeFromArray(ctrl.members, member);
        }


        // ** Misc
        function refresh() {
            var clubId = ctrl.clubId,
                subgroupId = ctrl.subgroupId;

            if (currentRefresh)
                currentRefresh.$cancelRequest();

            if (subgroupId)
                currentRefresh = Club.getSubgroupMembers({ id: clubId, clubSubgroupId: subgroupId }, success, error, true);
            else
                success([]);

            function success(members) {
                ctrl.members = members;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation) {
                    ctrl.members = [];
                    alert.error(resources.fetchSubgroupMembersFailed);
                }
            }
        }
        function search(text) {
            var clubId = ctrl.clubId,
                subgroupId = ctrl.subgroupId,
                params = { id: clubId, clubSubgroupId: subgroupId, text: text, $skip: 0, $top: subgroupMemberLookupPageSize };

            if (currentSearch)
                currentSearch.$cancelRequest();
            return (currentSearch = Club.searchSubgroupCandidates(params)).$promise.then(success);

            function success(data) {
                return data.members;
            }
        }
        function memberChanged(member, model) {
            copy(model || {}, member);
        }
        function editSubgroupKeyDown(e) {
            if (!e.isDefaultPrevented() && e.which == keys.ESC)
                ctrl.cancelSubgroup();
        }
        function editMemberKeyDown(e, member) {
            if (!e.isDefaultPrevented() && e.which == keys.ESC) {
                $window.focus(); // <== Buttons become unclickable unless this here (at least in IE)
                $timeout(ctrl.cancelMember.bind(ctrl, member)); //
            }
        }


        // ** Helpers
        function removeFromArray(array, item) {
            var index = array.indexOf(item);
            if (index != -1)
                array.splice(index, 1);
        }
        function getIsEditing() {
            var subgroup = ctrl.subgroup;
            return subgroup && subgroup.$isEditing;
        }
        function getSubgroupId(){
            return ctrl.subgroup && ctrl.subgroup.id || null;
        }
        function focusAddNewButton() {
            // This appears to work.  If the clientWidth = 0, then element is detached.  I don't want to walk the parentNodes to figure this out.
            if (!addMemberButton || !addMemberButton.clientWidth)
                addMemberButton = $element[0].querySelector('.sgp-add-member');
            if (addMemberButton)
                addMemberButton.focus();
        }
    }
})();